define.alias("shared/helpers/linkify-text", "calendar/helpers/linkify-text");